import { Chip } from '@heroui/react';
import type { FC } from 'react';

interface AccountDeactivatedBadgeProps {
  deactivatedAt?: string | null;
}

const AccountDeactivatedBadge: FC<AccountDeactivatedBadgeProps> = ({ deactivatedAt }) => {
  if (!deactivatedAt) {
    return null;
  }

  return (
    <Chip size='sm' variant='flat' color='danger'>
      Deactivated
    </Chip>
  );
};

export default AccountDeactivatedBadge;
